import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  debtBuildings: [],
};
const BuildingDebtSlice = createSlice({
  name: "ApartmentSlice",
  initialState: initialState,
  reducers: {
    addBuildingDebt: (state, action) => {
      state.debtBuildings = action.payload;
    },
  },
});
export const { addBuildingDebt } = BuildingDebtSlice.actions;
export default BuildingDebtSlice.reducer;
